import { render, staticRenderFns } from "./VacationConfirmAwaitingWidget.vue?vue&type=template&id=9e857bca&scoped=true&"
import script from "./VacationConfirmAwaitingWidget.vue?vue&type=script&lang=js&"
export * from "./VacationConfirmAwaitingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e857bca",
  null
  
)

export default component.exports